// extracted by mini-css-extract-plugin
export default {"container":"_98185b23","staticImage":"_6430051b"};